import clsx from "clsx";
import React from "react";
import styles from "./styles.module.scss";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, rows, error = false, ...props }, ref) => {
    return (
      <textarea
        rows={rows || 4}
        className={clsx(
          styles._onetouchai_textarea,
          error && styles._onetouchai_destructive,
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
